export const continueBonusProcessorMutation = (input) => `
  mutation continueBonusProcessor {
    continueBonusProcessor(
      campaign_id: "${input.campaignId}",
      type: "${input.type}"
      ) {
        historys {
          continue_status
          start
          end
        }
        first_continue {
          status
          index
        }
        incentive_requirement
        per_day
        is_continue_bonus_complete
        continue_bonus_point
    }
  }
`
